import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import Footer from '@/repositories/data/content/Footer';

export default class ContentPageRepository extends BaseCrudRepository<number, Footer, Footer> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/footer/');
    }
}
